<template>
  <div v-if="pincodeModal === false && smsModal === false" class="basket">
    <div
      style="padding-top: 28px"
      v-if="loader().WEBVIEW_MODE === loader().const.ECOMMERCE"
    ></div>
    <div class="basket_inner">
      <div class="basket_head">
        <div class="bh_left">
          <router-link
            :to="{ name: 'receipt', params: { token: this.$store.getters.token }}"
            class="bh_back"
          >
            <img
              :src="require('@/assets/img/facebook/back_str.svg')"
              alt="back"
            >
          </router-link>
          <div class="bh_title">{{ text('screen_form_title') }}</div>
        </div>
      </div>
      <div class="delivery">
        <div class="custom-order-text" v-if="$store.getters.showCustomOrderText" >
          {{text('screen_form_order_custom_text')}}
        </div>

        <template v-if="hasSpecialDeliveryMethods && !isOnlyDigitalItemsInBasket">
          <template v-if="$store.getters.outletSettings.company_use_kml">
            <text-input
              :field="'address'"
              :filled="filledDaDataInput || focused.includes('address') || address.length > 0"
              :label="text('screen_form_local_address_placeholder')"
              :value.sync="address"
              :hasSpecialDeliveryMethods="true"
              :fromBound="'street'"
              :toBound="'house'"
              :cityBound.sync="$store.getters.deliveryToCity"
              @focus="setFocusDaDataInput"
              @unfocus="unfocus"
              @updatePostalCode="updatePostalCode"
              v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress"
            />
          </template>
          <template v-else>
            <text-input
              :field="'localAddress'"
              :filled="filledDaDataInput || focused.includes('address') || localAddress.length > 0"
              :label="text('screen_form_local_address_placeholder')"
              :required="true"
              :value.sync="localAddress"
              :hasSpecialDeliveryMethods="true"
              @focus="setFocusDaDataInput"
              @unfocus="unfocus"
              @updatePostalCode="updatePostalCode"
              v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress"
            />
          </template>

          <text-input
            ref="deliveryAddressPostCodeInput"
            :field="'deliveryIndex'"
            :filled="focused.includes('deliveryIndex') || deliveryIndex.length > 0"
            :label="'Введите индекс'"
            :required="true"
            :value.sync="deliveryIndex"
            @focus="focus('deliveryIndex')"
            @unfocus="unfocus"
          />
        </template>

        <div
          class="form-info"
          v-if="$store.getters.outletSettings.comment"
        >
          <img
            :src="require('@/assets/img/facebook/info_ico_blue.svg')"
            alt="info"
          >
          <div>{{ $store.getters.outletSettings.comment }}</div>
        </div>

        <div
          @click="openTimeModal()"
          :class="{'select_block-calendar': deliveryTimeMode === DELIVERY_DAYS_TIME && !isDateNowMode}"
          class="select_block"
          v-if="timeSelector && !this.$store.getters.contactlessMode && !this.$store.getters.enableOnlinePayment && !hasSpecialDeliveryMethods && !isOnlyDigitalItemsInBasket"
        >
          <div class="sb_ico">
            <img
              :src="require('@/assets/img/facebook/delivery_ico.svg')"
              alt="delivery"
              v-if="isDelivery"
            >
            <img
              :src="require('@/assets/img/facebook/clock_ico.svg')"
              alt="clock"
              v-else
            >
          </div>
          <div class="sb_info" :style="{width: deliveryTimeMode === DELIVERY_DAYS_TIME ? '100%' : ''}">
            <div class="sb_title">{{ deliveryType }}</div>

            <div class="sb_select">
              <template v-if="deliveryTimeMode === DELIVERY_TIME">
                <template v-if="deliveryTimeObject.time.data === null">
                  {{ text('screen_form_select_date_and_time') }}
                </template>
                <template v-else>
                  <template v-if="deliveryTimeObject.time.asap === true">
                    <template v-if="isOutletCanStartPrepareOrderNow()">
                      {{ text('screen_form_as_fast_as_you_can') }} <span v-if="getMinutes() !== null"> {{ text('screen_form_approx_minutes', {'minutes':getMinutes() }) }}</span>
                    </template>
                    <template v-else>
                      {{ deliveryTimeObject.day.value }} {{ this.text('screen_form_at_time', { 'time': deliveryTimeObject.time.label }) }}
                    </template>
                  </template>
                  <template v-else>
                    {{ deliveryTimeObject.day.value }} {{
                    this.text('screen_form_at_time', { 'time': deliveryTimeObject.time.label }) }}
                  </template>
                </template>
              </template>

              <template v-if="deliveryTimeMode === DELIVERY_MONTHS_TIME">
                <template
                  v-if="!this.$store.getters.deliveryTimeObject.month.data || !this.$store.getters.deliveryTimeObject.day.data">
                  {{ text('screen_form_select_date') }}
                </template>
                <template v-else>
                  <template v-if="language === 'ru'">
                    {{ getMomentDateFormatted(this.$store.getters.deliveryTimeObject.time.data * 1000, 'DD.MM.YYYY') }}
                  </template>
                  <template v-else>
                    {{ this.$store.getters.deliveryTimeObject.month.value | capitalize }} {{
                      this.$store.getters.deliveryTimeObject.day.value }}
                  </template>
                </template>
              </template>

              <template v-if="deliveryTimeMode === DELIVERY_DAYS_TIME">
                <template v-if="isDateNowMode">
                  <div class="date-now-select">
                    <template v-if="isOutletCanStartPrepareOrderNow()">
                      {{ currentDeliveryDateNowText }} <span v-if="getMinutes() !== null && dateNowChecked"> {{ text('screen_form_approx_minutes', {'minutes':getMinutes() }) }}</span>
                    </template>
                    <template v-else>
                      {{ currentDeliveryDateNowText }}
                    </template>
                  </div>
                </template>
                <template v-else>
                  <date-picker
                    ref="datePickerDate"
                    v-model="deliveryDate"
                    :lang="getDatePickerLocale()"
                    :disabled-date="disabledBeforeTodayAndAfterAWeek"
                    @change="disableTime"
                    :class="{'delivery-error': deliveryError && !this.deliveryDate}"
                  ></date-picker>
                  <date-picker
                    v-if="!isIntervalDeliveryTime"
                    ref="datePickerTime"
                    v-model="deliveryTime"
                    :lang="getDatePickerLocale()"
                    :time-picker-options="{
                      start: timeStart,
                      step: '00:05',
                      end: timeEnd,
                    }"
                    format="HH:mm"
                    type="time"
                    value-type="HH:mm"
                    :placeholder="text('screen_form_select_date_and_time')"
                    @change="pickTime"
                    @open="timeHandler"
                    :class="{'delivery-error': deliveryError && !this.deliveryTime}"
                  ></date-picker>
                </template>

                <div v-if="isIntervalDeliveryTime" class="mx-input-wrapper iterval-time">
                  <select
                    class="mx-input"
                    v-model="intervalDeliveryTime"
                    @change="pickTime"
                    :class="{'delivery-error': deliveryError && !this.intervalDeliveryTime}"
                  >
                    <option disabled value="">{{text('screen_form_select_date_and_time')}}</option>
                    <option v-for="(time, idx) in intervalDeliveryTimeList" :key="idx" :value="time">{{time}}</option>
                  </select>
                </div>
              </template>

              <template v-if="deliveryTimeMode === DELIVERY_ONE_DAY">
                <template v-if="deliveryTimeObject.time.data === null">
                  {{ text('screen_form_select_date_and_time') }}
                </template>
                <template v-else>
                  <template v-if="deliveryTimeObject.time.asap === true">
                    <template v-if="isOutletCanStartPrepareOrderNow()">
                      {{ text('screen_form_as_fast_as_you_can') }} <span v-if="getMinutes() !== null"> {{ text('screen_form_approx_minutes', {'minutes':getMinutes() }) }}</span>
                    </template>
                    <template v-else>
                      {{ deliveryTimeObject.day.value }} {{ this.text('screen_form_at_time', { 'time': deliveryTimeObject.time.label }) }}
                    </template>
                  </template>
                  <template v-else>
                    {{ deliveryTimeObject.day.value }} {{
                    this.text('screen_form_at_time', { 'time': deliveryTimeObject.time.label }) }}
                  </template>
                </template>
              </template>
            </div>
          </div>
        </div>

        <DeliveryServices
          :delivery-services="$store.getters.deliveryServices"
          :selected.sync="deliveryService"
          :selectedType.sync="deliveryServiceType"
          :selectedDeliveryMethodCalc.sync="deliveryMethodCalcId"
          v-if="$store.getters.deliveryServices.length !== 0"
        />

        <div
          class="select_block select_block_lock "
          v-if="!isDelivery && deliveryService === null && !this.$store.getters.contactlessMode && !this.$store.getters.enableOnlinePayment && this.$store.getters.fieldAddress && !isOnlyDigitalItemsInBasket"
        >
          <div class="sb_ico"><img
            :src="require('@/assets/img/facebook/street_ico.svg')"
            alt="outlet"
          ></div>
          <div class="sb_info">
            <div class="sb_title">{{ text('screen_form_outlet_address') }}</div>
            <div class="sb_select">
              {{ outletAddress }}
            </div>
          </div>
        </div>

        <form class="delivery_form">

          <text-input
            :field="'fullAddress'"
            :filled="focused.includes('fullAddress') || fullAddress.length > 0"
            :label="text('screen_form_full_delivery_address')"
            :required="requiredFields.includes('fullAddress')"
            :value.sync="fullAddress"
            @focus="focus('fullAddress')"
            @unfocus="unfocus"
            v-show="(this.isDelivery || this.deliveryService) &&  fieldFullAddress && !isOnlyDigitalItemsInBasket"
          />

          <template v-if="!hasSpecialDeliveryMethods">
            <template v-if="$store.getters.outletSettings.company_use_kml">
              <!--                        <text-input :field="'address'"-->
              <!--                                    :filled="true" :label="text('screen_form_delivery_address')"-->
              <!--                                    :locked="true" :required="requiredFields.includes('address')"-->
              <!--                                    :value="address"-->
              <!--                                    v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress"-->
              <!--                        />-->
              <template v-if="!$store.getters.isHasGeo && ((this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket)">
                <!-- <div
                  class="in_2"
                  v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
                > -->

                    <text-input
                      :field="'cityName'"
                      :filled="focused.includes('cityName') || cityName.length > 0"
                      :label="text('screen_form_city')"
                      :required="requiredFields.includes('cityName')"
                      :value.sync="cityName"
                      @focus="focus('cityName')"
                      @unfocus="unfocus"
                      v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
                    />


                    <text-input
                      :field="'address'"
                      :filled="focused.includes('address') || address.length > 0"
                      :label="text('screen_form_local_address_placeholder')"
                      :required="requiredFields.includes('address')"
                      :value.sync="address"
                      @focus="focus('address')"
                      @unfocus="unfocus"
                      v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
                    />

                <!-- </div> -->
              </template>
              <template v-else>
                <!-- Inputs for IIKO -->
                <text-input
                  :field="'address'"
                  :filled="focused.includes('address') || address.length > 0"
                  :label="text('screen_form_delivery_address')"
                  :locked="true"
                  :required="requiredFields.includes('address')"
                  :value.sync="address"
                  @focus="focus('address')"
                  @unfocus="unfocus"
                  v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
                />
              </template>
            </template>
            <template v-else>
              <template v-if="!$store.getters.isHasGeo && ((this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket)">
                <!-- <div
                  class="in_2"
                  v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
                > -->

                    <text-input
                      :field="'cityName'"
                      :filled="focused.includes('cityName') || cityName.length > 0"
                      :label="text('screen_form_city')"
                      :required="requiredFields.includes('cityName')"
                      :value.sync="cityName"
                      @focus="focus('cityName')"
                      @unfocus="unfocus"
                      v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
                    />


                    <text-input
                      :field="'localAddress'"
                      :filled="focused.includes('localAddress') || localAddress.length > 0"
                      :label="text('screen_form_local_address_placeholder')"
                      :required="requiredFields.includes('localAddress')"
                      :value.sync="localAddress"
                      @focus="focus('localAddress')"
                      @unfocus="unfocus"
                      v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
                    />

                <!-- </div> -->
              </template>
              <template v-else>
                <text-input
                  :field="'localAddress'"
                  :filled="focused.includes('localAddress') || localAddress.length > 0"
                  :label="text('screen_form_delivery_address')"
                  :required="requiredFields.includes('localAddress')"
                  :value.sync="localAddress"
                  @focus="focus('localAddress')"
                  @unfocus="unfocus"
                  v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
                />
              </template>
            </template>
          </template>

          <div
            class="in_2"
            v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
          >
            <div class="in_2_block">
              <text-input
                :field="'apartment'"
                :filled="focused.includes('apartment') || apartment.length > 0"
                :label="text('screen_form_apartment')"
                :required="requiredFields.includes('apartment')"
                :value.sync="apartment"
                @focus="focus('apartment')"
                @unfocus="unfocus"
              />
            </div>
            <div class="in_2_block">
              <text-input
                :field="'porch'"
                :filled="focused.includes('porch') || porch.length > 0"
                :label="text('screen_form_porch')"
                :required="requiredFields.includes('porch')"
                :value.sync="porch"
                @focus="focus('porch')"
                @unfocus="unfocus"
              />
            </div>
          </div>

          <div
            class="in_2"
            v-show="(this.isDelivery || this.deliveryService) &&  fieldLocalAddress && !isOnlyDigitalItemsInBasket"
          >
            <div class="in_2_block">
              <text-input
                :field="'intercom'"
                :filled="focused.includes('intercom') || intercom.length > 0"
                :label="text('screen_form_intercom')"
                :required="requiredFields.includes('intercom')"
                :value.sync="intercom"
                @focus="focus('intercom')"
                @unfocus="unfocus"
              />
            </div>
            <div class="in_2_block">
              <text-input
                :field="'floor'"
                :filled="focused.includes('floor') || floor.length > 0"
                :label="text('screen_form_floor')"
                :required="requiredFields.includes('floor')"
                :value.sync="floor"
                @focus="focus('floor')"
                @unfocus="unfocus"
              />
            </div>
          </div>

          <text-input
            :field="'fullName'"
            :filled="focused.includes('fullName') || fullName.length > 0"
            :label="text('screen_form_full_name')"
            :required="requiredFields.includes('fullName')"
            :value.sync="fullName"
            @focus="focus('fullName')"
            @unfocus="unfocus"
            v-show="(this.isDelivery || this.deliveryService) && fieldFullName"
          />

          <phone-input
            :field="'recipientPhone'"
            :filled="true"
            :iti.sync="recipientPhoneITIInstance"
            :label="text('screen_form_recipient_phone')"
            :phone.sync="recipientPhone"
            :required="requiredFields.includes('recipientPhone')"
            @focus="focus('recipientPhone')"
            @unfocus="unfocus"
            v-show="(this.isDelivery || this.deliveryService) && fieldRecipientPhone"
          />

          <text-input
            v-if="this.$store.getters.shopMode === 0 ? this.$store.getters.outlet.data.webview_settings.formNameShow : this.$store.getters.outlet.webview_settings.formNameShow"
            :field="'name'"
            :filled="focused.includes('name') || name.length > 0"
            :label="text('screen_form_name')"
            :required="requiredFields.includes('name')"
            :value.sync="name"
            @focus="focus('name')"
            @unfocus="unfocus"
          />

          <phone-input
            v-if="this.$store.getters.fieldMainPhone"
            :field="'phone'"
            :filled="true"
            :iti.sync="phoneITIInstance"
            :label="text('screen_form_phone')"
            :phone.sync="phone"
            :required="requiredFields.includes('phone')"
            @focus="focus('phone')"
            @unfocus="unfocus"
          />

          <text-input
            :field="'email'"
            :filled="focused.includes('email') || email.length > 0"
            :label="text('screen_form_email')"
            :required="requiredFields.includes('email') || hasDigitalItem"
            :value.sync="email"
            @focus="focus('email')"
            @unfocus="unfocus"
            v-show="fieldEmail || hasDigitalItem"
          />

          <text-input
            :field="'comment'"
            :filled="focused.includes('comment') || comment.length > 0"
            :label="text('screen_form_comment')"
            :required="requiredFields.includes('comment')"
            :value.sync="comment"
            @focus="focus('comment')"
            @unfocus="unfocus"
            v-show="fieldComment"
          />

          <template v-if="this.$store.getters.fieldCustomFields.length > 0">
            <text-input
              v-for="customField in this.$store.getters.fieldCustomFields"
              :key="`customField${customField.id}`"
              :field="`custom${customField.id}`"
              :filled="focused.includes(`custom${customField.id}`) || customField.value.length > 0"
              :label="customField.name"
              :required="requiredFields.includes(`custom${customField.id}`)"
              :value.sync="customField.value"
              @focus="focus(`custom${customField.id}`)"
              @unfocus="unfocus"
            />
          </template>

          <template v-if="this.$store.getters.guardAreaID !== null && this.$store.getters.guardAreaID.form_settings.formCustomFields.length > 0 && this.$store.getters.guardAreaID.form_settings.formCustomFields.length !== null && this.$store.getters.guardAreaID.form_settings.formCustomFields.length !== undefined">
            <text-input
              v-for="districtCustomField in this.$store.getters.guardAreaID.form_settings.formCustomFields"
              :key="`customField${districtCustomField.id}`"
              :field="`custom${districtCustomField.id}`"
              :filled="focused.includes(`custom${districtCustomField.id}`) || districtCustomField.value.length > 0"
              :label="districtCustomField.name"
              :required="requiredFields.includes(`custom${districtCustomField.id}`)"
              :value.sync="districtCustomField.value"
              @focus="focus(`custom${districtCustomField.id}`)"
              @unfocus="unfocus"
            />
          </template>

          <div
            class="qty_devices_block"
            v-if="$store.getters.cutlery"
          >
            <div
              class="pu_tovar_nav_btn"
              :class="{'pu_tovar_nav_btn_none': this.qtyDevices === 0}"
              style="width: 100%; padding-right: 8px;"
            >
              <div style="height: 100%; font-weight: 400;">
                <span style="line-height: 52px;">{{text('persons_qty')}}</span>
              </div>
            </div>
            <span class="plus-minus">
              <input
                type="text"
                name="count"
                :value="qtyDevices"
                readonly
              >
              <a
                class="cart__count-down"
                @click="changeCount(-1)"
              >
                <svg
                  width="12"
                  height="2"
                  viewBox="0 0 12 2"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2H1C0.447715 2 0 1.55228 0 1Z"
                    fill="#1A1A1B"
                  />
                </svg>
              </a>
              <a
                class="cart__count-up"
                @click="changeCount(1)"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1C7 0.447715 6.55228 0 6 0Z"
                    fill="#1A1A1B"
                  />
                </svg>
              </a>
            </span>
          </div>

          <div
            class="delivery_oplata"
            v-if="!isFreeOrder && paymentMethods && Object.keys(paymentMethods).length"
          >
            <div class="do_title">
              {{ text('screen_form_pay_method') }}
            </div>
            <div class="delivery_oplata_list">

              <label
                class="dol_block"
                v-for="paymentMethod in paymentMethods"
                :key="paymentMethod.id"
              >
                <input
                  :value="paymentMethod"
                  name="dol"
                  type="radio"
                  v-model="payment"
                />
                <div class="dol_content">
                  <div
                    class="dol_ico"
                    v-if="paymentMethod.custom !== true"
                  >
                    <template v-if="paymentMethod.id === 1">
                      <svg
                        fill="none"
                        height="16"
                        viewBox="0 0 20 16"
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 0H2C0.895 0 0 0.895 0 2V14C0 15.105 0.895 16 2 16H18C19.105 16 20 15.105 20 14V2C20 0.895 19.105 0 18 0ZM4.5 13H3.5C3.224 13 3 12.776 3 12.5V11.5C3 11.224 3.224 11 3.5 11H4.5C4.776 11 5 11.224 5 11.5V12.5C5 12.776 4.776 13 4.5 13ZM5.5 6H3.5C3.224 6 3 5.776 3 5.5V3.5C3 3.224 3.224 3 3.5 3H5.5C5.776 3 6 3.224 6 3.5V5.5C6 5.776 5.776 6 5.5 6ZM8.5 13H7.5C7.224 13 7 12.776 7 12.5V11.5C7 11.224 7.224 11 7.5 11H8.5C8.776 11 9 11.224 9 11.5V12.5C9 12.776 8.776 13 8.5 13ZM12.5 13H11.5C11.224 13 11 12.776 11 12.5V11.5C11 11.224 11.224 11 11.5 11H12.5C12.776 11 13 11.224 13 11.5V12.5C13 12.776 12.776 13 12.5 13ZM16.5 13H15.5C15.224 13 15 12.776 15 12.5V11.5C15 11.224 15.224 11 15.5 11H16.5C16.776 11 17 11.224 17 11.5V12.5C17 12.776 16.776 13 16.5 13ZM16.5 6H11.5C11.224 6 11 5.776 11 5.5V4.5C11 4.224 11.224 4 11.5 4H16.5C16.776 4 17 4.224 17 4.5V5.5C17 5.776 16.776 6 16.5 6Z"
                          fill="#CCCCCC"
                        />
                      </svg>
                    </template>
                    <svg
                      fill="none"
                      height="21"
                      v-if="paymentMethod.id === 2"
                      viewBox="0 0 22 21"
                      width="22"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0L4.45117 1.58594C3.59217 1.83094 3 2.61677 3 3.50977V5H1C0.448 5 0 5.448 0 6V16C0 16.552 0.448 17 1 17H3V18C3 19.657 4.343 21 6 21H15.0273C15.5353 21 16.0255 20.807 16.3965 20.459L20.7734 16.3555C21.3954 15.7725 21.4429 14.8002 20.8789 14.1602C20.4349 13.6562 19.7216 13.4872 19.0996 13.7402L16 15H2.91211C2.83749 14.7897 2.7169 14.5987 2.55911 14.4409C2.40132 14.2831 2.21031 14.1625 2 14.0879V7.91211C2.21031 7.83749 2.40132 7.7169 2.55911 7.55911C2.7169 7.40131 2.83749 7.21031 2.91211 7H3H16H17.0879C17.1625 7.21031 17.2831 7.40131 17.4409 7.55911C17.5987 7.7169 17.7897 7.83749 18 7.91211V11C18 11.552 18.448 12 19 12C19.552 12 20 11.552 20 11V6C20 5.448 19.552 5 19 5H16V2C16 0.895 15.105 0 14 0H10ZM10 8.5C9.33696 8.5 8.70107 8.76339 8.23223 9.23223C7.76339 9.70107 7.5 10.337 7.5 11C7.5 11.663 7.76339 12.2989 8.23223 12.7678C8.70107 13.2366 9.33696 13.5 10 13.5C10.663 13.5 11.2989 13.2366 11.7678 12.7678C12.2366 12.2989 12.5 11.663 12.5 11C12.5 10.337 12.2366 9.70107 11.7678 9.23223C11.2989 8.76339 10.663 8.5 10 8.5V8.5ZM5 10C4.448 10 4 10.447 4 11C4 11.553 4.448 12 5 12C5.552 12 6 11.553 6 11C6 10.447 5.552 10 5 10ZM15 10C14.448 10 14 10.447 14 11C14 11.553 14.448 12 15 12C15.552 12 16 11.553 16 11C16 10.447 15.552 10 15 10Z"
                        fill="#CCCCCC"
                      />
                    </svg>
                    <svg
                      fill="none"
                      height="17"
                      v-if="paymentMethod.id === 3"
                      viewBox="0 0 21 17"
                      width="21"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 0C7.895 0 7 0.895 7 2V3H21V2C21 0.895 20.105 0 19 0H9ZM7 5V9C7 9.434 7.14195 9.83216 7.37695 10.1602L11.9102 7.33594C12.7782 6.79494 13.9149 6.99478 14.5449 7.80078L15.2734 8.73438C15.7874 9.39237 16.0222 10.2 15.9922 11H19C20.105 11 21 10.105 21 9V5H7ZM3.74805 5.0918C3.53434 5.10097 3.31594 5.16864 3.11719 5.30664L0.859375 6.87695C0.321375 7.24995 0 7.86258 0 8.51758V15C0 16.105 0.895 17 2 17H7.58203C8.70203 17 9.74814 16.4398 10.3691 15.5078L13.7305 11.7246C14.1125 11.1966 14.0993 10.4798 13.6973 9.9668C13.2523 9.2898 12.687 9.17772 12 9.63672L7.60352 12.377C6.46952 13.084 5 12.2676 5 10.9316V6.29102C5 5.56577 4.38916 5.06428 3.74805 5.0918Z"
                        fill="#CCCCCC"
                      />
                    </svg>
                    <svg
                      fill="none"
                      height="19"
                      v-if="paymentMethod.id === 4"
                      viewBox="0 0 18 19"
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 0C4.90694 0 4 0.906937 4 2V3H2C0.895 3 0 3.895 0 5V13H18V5C18 3.895 17.105 3 16 3H14V2C14 0.906937 13.0931 0 12 0H6ZM6 2H12V3V4V7H6V4V3V2ZM5 9C5.552 9 6 9.448 6 10C6 10.552 5.552 11 5 11C4.448 11 4 10.552 4 10C4 9.448 4.448 9 5 9ZM9 9C9.552 9 10 9.448 10 10C10 10.552 9.552 11 9 11C8.448 11 8 10.552 8 10C8 9.448 8.448 9 9 9ZM13 9C13.552 9 14 9.448 14 10C14 10.552 13.552 11 13 11C12.448 11 12 10.552 12 10C12 9.448 12.448 9 13 9ZM0 15V17C0 18.105 0.895 19 2 19H16C17.105 19 18 18.105 18 17V15H10C10 15.552 9.552 16 9 16C8.448 16 8 15.552 8 15H0Z"
                        fill="#CCCCCC"
                      />
                    </svg>
                  </div>
                  <div class="dol_inner">
                    <div class="dol_name">
                      <template v-if="paymentMethod.id === 1">
                        <template>{{ text('payment_method_online') }}</template>
                      </template>
                      <template v-else>
                        <template v-if="paymentMethod.name">{{ paymentMethod.name }}</template>
                        <template v-else>{{ text(paymentMethod.template) }}</template>
                      </template>
                      <img
                        style="display: block; width: 75px; margin: 2px 0;"
                        :src="require('@/assets/img/applepay_googlepay.png')"
                        v-if="showApplePayGooglePay(paymentMethod)"
                      >
                    </div>
                    <div
                      class="dol_dop"
                      v-if="paymentMethod.custom !== true"
                    >
                      <div
                        class="dol_dop_text"
                        :class="{'ios-font': $store.getters.checkIos}"
                        v-html="text('screen_form_online_pay_desc', {'amount':$options.filters.toCurrency($store.getters.totalPrice)})"
                        v-if="paymentMethod.id === 1 && paymentMethod.twoStep"
                      >
                      </div>
                      <div
                        class="dol_dop_text"
                        v-html="sanitize(paymentMethod.comment.replace(/\n/g, '<br>'))"
                        v-if="paymentMethod.comment && payment && payment.id === paymentMethod.id"
                      ></div>
                      <input
                        :placeholder="text('screen_form_need_change_for')"
                        class="dol_dop_input"
                        type="text"
                        v-if="paymentMethod.id === 2"
                        v-model="delivery"
                      />
                    </div>
                    <div v-else>
                      <div
                        class="dol_dop_text"
                        v-html="sanitize(paymentMethod.comment.replace(/\n/g, '<br>'))"
                        v-if="paymentMethod.comment && payment && payment.id === paymentMethod.id"
                      ></div>
                    </div>
                  </div>
                </div>
              </label>

            </div>
          </div>


          <!-- <span
            class="input input_style bl_comment"
            v-if="this.$store.getters.contactlessMode"
            :class="{ 'input--filled': focused.includes('cookComment') || cookComment.length > 0 }"
          >
          <input
            class="input__field input__field--ruri"
            type="text"
            v-model="cookComment"
            id="input_cookComment"
            @focus="focus('cookComment', 'input_cookComment')"
            @blur="unfocus"
          />
          <label
            class="input__label"
            for="input_cookComment"
          >
            <span class="input__label-content">{{ text('screen_basket_comment') }}</span>
          </label>
        </span> -->

          <TipsSelector
              ref="tipsSelector"
              :default-method="defaultMethod()"
              :payment-method="payment"
          />
        </form>
      </div>
    </div>

    <div class="fixed_bottom_basket unfix plr">
      <template v-if="$store.getters.cashbackSettings.available && $store.getters.cashbackSettings.balance > 0">

        <div
          class="basket_cashback"
          v-if="!cashback.use"
        >
          <div class="cashback_balance">
            {{ text('screen_form_cashback_balance', {'amount': $store.getters.cashbackSettings.balance
            }) }}
          </div>
          <div
            @click="toggleCashbackUse()"
            class="cashback_use"
          >{{
            text('screen_form_cashback_use').toUpperCase() }}
          </div>
        </div>
        <div
          class="basket_cashback"
          v-else
        >
          <span>{{ text('screen_form_cashback_use') }}</span>
          <input
            :max='$store.getters.cashbackSettings.max'
            class="input input_style bfl_input cashback_input"
            name="cashback_amount"
            type="number"
            v-model="cashback.amount"
          />
          <div
            @click="toggleCashbackUse()"
            class="cashback_use"
          >{{
            text('screen_form_cashback_reset').toUpperCase() }}
          </div>
        </div>

        <template v-if="cashback.use">
          <div
            class="basket_slider"
            style="display: block"
          >
            <vue-slider
              :adsorb="true"
              :data="$store.getters.cashbackSettings.sliderData"
              :dotSize="[20,20]"
              :height="3"
              :max="$store.getters.cashbackSettings.max"
              :min="0"
              :tooltip="'none'"
              ref="slider"
              v-model="cashback.amount"
            ></vue-slider>
          </div>
        </template>

      </template>
      <a
        @click="blockOrderButton(true); makeOrder()"
        class="fbb_btn"
        :class="{ buttonBlocked: isOrderButtonBlocked }"
      >
        <template v-if="$store.getters.loading[MAKE_ORDER] === true">
          <svg
            class="svg_anim"
            version="1.1"
            viewBox="0 0 130.2 130.2"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              class="path circle"
              cx="65.1"
              cy="65.1"
              fill="none"
              r="57.1"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="7"
            />
          </svg>
        </template>
        <template v-else>
          <template v-if="!makeOrderStatus">
            {{ orderButtonText }}
            <i
              class="bfi_basket_price"
              :class="{ 'ios-font': $store.getters.checkIos }"
              v-html="$options.filters.toCurrency($store.getters.totalPrice)"
            ></i>
          </template>
          <template v-else>
            <svg
              class="svg_anim"
              version="1.1"
              viewBox="0 0 130.2 130.2"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polyline
                class="path check"
                fill="none"
                points="100.2,40.2 51.5,88.8 29.8,67.5 "
                stroke="#fff"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="6"
              />
            </svg>
          </template>
        </template>

      </a>
      <!-- чаевые -->
      <span
          class="tips-text"
          :class="{ 'ios-font': $store.getters.checkIos }"
          v-if="$refs.tipsSelector && $refs.tipsSelector.tips && $refs.tipsSelector.checked && $refs.tipsSelector.tipsSum"
      >
        Чаевые <b>{{$refs.tipsSelector.tipsSum}} ₽</b> будут списаны отдельным платежом сразу после оплаты заказа.
      </span>
      <!-- оферта -->
      <span
        class="agree-text"
        v-html="sanitize(text('screen_form_agree_text', {'button': orderButtonText}))"
        v-if="showAgreeText"
      ></span>
    </div>

    <DeliveryTime v-if="deliveryTimeMode === DELIVERY_TIME && !intervalMode"/>
    <DeliveryIntervalTime v-if="deliveryTimeMode === DELIVERY_TIME && intervalMode"/>
    <DeliveryDaysTime v-if="deliveryTimeMode === DELIVERY_DAYS_TIME && !intervalMode"/>
    <DeliveryDaysIntervalTime v-if="deliveryTimeMode === DELIVERY_DAYS_TIME && intervalMode"/>
    <DeliveryMonthsTime v-if="deliveryTimeMode === DELIVERY_MONTHS_TIME"/>
    <DeliveryOneDay v-if="deliveryTimeMode === DELIVERY_ONE_DAY && !intervalMode"/>
    <DeliveryIntervalTime v-if="deliveryTimeMode === DELIVERY_ONE_DAY && intervalMode"/>

    <div v-if="isDateNowMode">
      <transition name="fade">
        <div :key="'compact_selector_dark'" class="pu_dark pu_dark-date-now" v-show="openDeliveryTime"></div>
      </transition>
      <transition name="slide">
        <div :key="'compact_selector'" class="pu_bottom popup_click_hide pu_bottom-date-now" v-show="openDeliveryTime">
          <div class="pu_bottom_scroll">
            <div  class="pu_b_close" @click="openDeliveryTime = !openDeliveryTime"></div>
            <div class="pu_bottom_inner ">
              <div class="pu_select pu_select__date-now" style="display: block">
                <label class="date-now">
                  <input
                    :checked="dateNowChecked"
                    :value="timeStart"
                    name="timeDeliveryNow"
                    type="radio"
                    class="date-now_input"
                    @change="updateTimeDelivery()"
                  />
                  <div class="date-now-content">
                    <div class="date-now-inner">
                      <div class="date-now_name">
                        <template v-if="isOutletCanStartPrepareOrderNow()">
                          {{ text('screen_form_as_fast_as_you_can') }} <span v-if="getMinutes() !== null"> {{ text('screen_form_approx_minutes', {'minutes':getMinutes() }) }}</span>
                        </template>
                        <template v-else>
                          {{ this.getMomentDateFormatted(this.getNearestOrderPreparationDate(), (language === 'ru' ? 'DD.MM.YYYY' : 'YYYY-MM-DD')) }} {{ this.text('screen_form_at_time', { 'time': this.getMomentDateFormatted(this.getNearestOrderPreparationDate(), 'HH:mm') }) }}
                        </template>
                      </div>
                    </div>
                  </div>

                </label>
                <date-picker
                  ref="datePickerDate"
                  v-model="deliveryDate"
                  :lang="getDatePickerLocale()"
                  :format="language === 'ru' ? 'DD.MM.YYYY' : 'YYYY-MM-DD'"
                  :disabled-date="disabledBeforeTodayAndAfterAWeek"
                  @change="disableTime"
                ></date-picker>
                <date-picker
                  v-if="!isIntervalDeliveryTime"
                  ref="datePickerTime"
                  v-model="deliveryTime"
                  :lang="getDatePickerLocale()"
                  default-value=""
                  :time-picker-options="{
                      start: timeStart,
                      step: '00:05',
                      end: timeEnd,
                    }"
                  format="HH:mm"
                  type="time"
                  :placeholder="text('screen_form_select_date_and_time')"
                  @change="pickTime"
                  @open="timeHandler"
                  :class="{'delivery-error': deliveryError}"
                ></date-picker>
              </div>
              <div class="pu_tovar_nav pu_tovar_nav_one">
                <div class="pu_tovar_nav_btn">
                  <a  class="fbb_btn" @click="openDeliveryTime = !openDeliveryTime">
                    {{ currentDeliveryDateNowText }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

  </div>

  <div v-else-if="pincodeModal === true" class="basket">
    <div
      style="padding-top: 28px"
      v-if="loader().WEBVIEW_MODE === loader().const.ECOMMERCE"
    ></div>
    <div class="basket_inner">
      <div class="basket_head">
        <div class="bh_left">
          <a
            class="bh_back"
            @click="togglePin(false)"
          >
            <img
              :src="require('@/assets/img/facebook/back_str.svg')"
              alt="back"
            >
          </a>
          <div class="bh_title">{{ text('screen_form_title') }}</div>
        </div>
      </div>
      <div class="delivery pincode">
        <div class="pincode__info" v-html="$store.getters.texts.pin_code_info_message"></div>

        <div class="pincode__input" :class="{error: pincodeError}">
            <text-input
              :field="'pincode'"
              :filled="focused.includes('pincode') || pincode.length > 0"
              :label="$store.getters.texts.pin_code_label"
              :required="requiredFields.includes('pincode')"
              :value.sync="pincode"
              @focus="focus('pincode')"
              @unfocus="unfocus"
            />

            <div class="pincode__input_error" :class="{show: pincodeError}">
              {{ $store.getters.texts.pin_code_validate_error_message }}
            </div>
        </div>

        <div class="pincode__button">
          <div  class="fbb_btn" @click="checkPinCode()">
            {{ $store.getters.texts.pin_code_submit }}
          </div>
        </div>

        <div v-if="pincodeError === true" class="pincode__error">
          {{ $store.getters.texts.pin_code_error_message }}
        </div>
      </div>
    </div>

  </div>

  <SMSCheck
      v-else-if="smsModal === true"
      :makeOrderPayload="makeOrderPayload"
      :phone="this.phone"
      @closeSms="toggleSms(false)"
    />
</template>

<script>
  import api from '@/api'
  import axios from 'axios'

  let debounce = require('lodash.debounce')

  import * as moment from 'moment'

  import VueScrollTo from 'vue-scrollto'
  import {isIOS, isIOS13, isAndroid} from 'mobile-device-detect'

  import Basket from '@/components/Default/Basket'
  import PhoneInput from '@/components/Default/Input/PhoneInput'
  import TextInput from '@/components/Default/Input/TextInput'
  import DeliveryServices from '@/components/Default/Form/DeliveryServices'
  import DeliveryMethods from '@/components/Default/Form/DeliveryMethods'
  import DeliveryTime from '@/components/Default/Form/DeliveryTime/DeliveryTime'
  import DeliveryIntervalTime from '@/components/Default/Form/DeliveryTime/DeliveryIntervalTime'
  import DeliveryDaysTime from '@/components/Default/Form/DeliveryTime/DeliveryDaysTime'
  import DeliveryDaysIntervalTime from '@/components/Default/Form/DeliveryTime/DeliveryDaysIntervalTime'
  import DeliveryMonthsTime from '@/components/Default/Form/DeliveryTime/DeliveryMonthsTime'
  import DeliveryOneDay from '@/components/Default/Form/DeliveryTime/DeliveryOneDay'
  import SMSCheck from '@/components/Default/Form/SMSCheck'
  import VueSlider from 'vue-slider-component'
  import '@/assets/scss/vue-slider-component/facebook.scss'
  import {mapGetters} from 'vuex'
  import {
    SET_DELIVERY_TIME_MODE, SET_DELIVERY_TIME_OBJECT, SET_FIELD_CUSTOM_FIELDS,
    SET_FIELD_EMAIL,
    SET_FIELD_FULL_ADDRESS,
    SET_FIELD_FULL_NAME,
    SET_FIELD_LOCAL_ADDRESS,
    SET_FIELD_RECIPIENT_PHONE,
    SET_FIELD_MAIN_PHONE,
    SET_FIELD_COMMENT,
    SET_LOADING, SET_MODAL,
    SET_PAYMENT_METHODS,
    SET_TIME_SELECTOR, SET_TOTAL_PRICE,
    SET_CUTLERY,
    SET_TIMES,
    SET_STATUS,
    SET_COOK_COMMENT,
    SET_ACTIVE_DELIVERY_METHOD,
    SET_SPECIAL_DELIVERY_METHOD
  } from '@/store/mutations.type'
  import {
    DISABLE_OVERLAY, FETCH_TIMES, MAKE_ORDER, CHECK_IIKO, FETCH_OUTLET_ADDITIONAL, CALC_RUSSIAN_POST, CALC_CDEK, CALC_TK_PEK
  } from '@/store/actions.type'
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'
  import TipsSelector from "@/components/Default/TipsSelector.vue";

  export default {
    name: 'Form',
    components: {
      TipsSelector,
      Basket,
      DeliveryTime,
      DeliveryIntervalTime,
      DeliveryDaysTime,
      DeliveryDaysIntervalTime,
      DeliveryMonthsTime,
      DeliveryOneDay,
      VueSlider,
      DeliveryServices,
      DeliveryMethods,
      SMSCheck,
      TextInput,
      PhoneInput,
      DatePicker
    },
    data() {
      return {
        tipsAmount: '',
        dateNowChecked: false,
        cookComment: '',
        deliveryTime: '',
        deliveryDate: '',
        timeStart: '',
        timeEnd: '',
        intervalDeliveryTime: '',
        intervalDeliveryTimeList: [],
        isIntervalDeliveryTime: false,
        deliveryError: false,
        name: '',
        apartment: '',
        intercom: '',
        porch: '',
        floor: '',
        comment: '',
        email: '',
        focused: '',
        payment: this.defaultMethod(),
        deliveryService: null,
        deliveryServiceType: null,
        deliveryMethod: null,
        openDeliveryTime: false,
        isDateNowMode: false,
        hasSpecialDeliveryMethods: false,
        delivery: '',
        phone: '',
        address: '',
        cityName: this.$store.getters.deliveryToCity || '',
        localAddress: '',
        fullAddress: '',
        deliveryIndex: this.$store.getters.postCode || '',
        deliveryMethodCalcId: null,
        filledDaDataInput: false,
        fullName: '',
        recipientPhone: '',
        qtyDevices: this.$store.getters.cutlery ? 1 : 0,
        cashback: {
          use: false,
          amount: 0
        },

        requiredFields: [],

        phoneITIInstance: null,
        recipientPhoneITIInstance: null,
        makeOrderPayload: {},

        isOnlyDigitalItemsInBasket: true,
        hasDigitalItem: false,

        MAKE_ORDER, FETCH_OUTLET_ADDITIONAL,

        isOrderButtonBlocked: false,

        isPincode: this.$store.getters.shopMode === 0 ? this.$store.getters.outlet.data.webview_settings.enable_check_pin_code : this.$store.getters.outlet.webview_settings.enable_check_pin_code,
        pincodeModal: false,
        pincode: '',
        pincodeError: false,
        pincodeCheck: false,
        smsModal: false,
      }
    },
    mounted() {
      this.$store.getters.selectedProducts.forEach(item => {
        if (item.is_digital) {
          this.hasDigitalItem = true
        } else {
          this.isOnlyDigitalItemsInBasket = false
        }
      })
      this.cashback.amount = Math.floor(this.$store.getters.cashbackSettings.max / 3)
      this.cashback.amount -= this.cashback.amount % 5

      if (this.$store.getters.profile) {

        if (this.$store.getters.profile.first_name) {
          this.name = this.$store.getters.profile.first_name
        }
        if (this.$store.getters.profile.phone) {
          this.phone = String(this.$store.getters.profile.phone)
        }

        if (this.$store.getters.profile.email) {
          this.email = this.$store.getters.profile.email
        }
        if (this.$store.getters.profile.address) {
          this.address = this.$store.getters.profile.address
        }
        if (this.$store.getters.profile.cityName) {
          this.cityName = this.$store.getters.profile.cityName
        }
        if (this.$store.getters.profile.fullAddress) {
          this.fullAddress = this.$store.getters.profile.fullAddress
        }
        if (this.$store.getters.profile.localAddress) {
          this.localAddress = this.$store.getters.profile.localAddress
        }
        if (this.$store.getters.profile.deliveryIndex) {
          this.deliveryIndex = this.$store.getters.profile.deliveryIndex
        }
        if (this.$store.getters.profile.fullName) {
          this.fullName = this.$store.getters.profile.fullName
        }
        if (this.$store.getters.profile['flat']) {
          this.apartment = this.$store.getters.profile['flat'].toString()
        }
        if (this.$store.getters.profile['floor']) {
          this.floor = this.$store.getters.profile['floor'].toString()
        }
        if (this.$store.getters.profile.porch) {
          this.porch = this.$store.getters.profile.porch.toString()
        }
        if (this.$store.getters.profile.domofon) {
          this.intercom = this.$store.getters.profile.domofon.toString()
        }
      }


      let localStorageForm = this.getFormFromLocalStorage()

      if (localStorageForm.name) {
        this.name = localStorageForm.name
      }
      if (localStorageForm.fullName) {
        this.fullName = localStorageForm.fullName
      }
      if (localStorageForm.localAddress) {
        this.localAddress = localStorageForm.localAddress
      }
      if (localStorageForm.cityName) {
        this.cityName = localStorageForm.cityName
      }
      if (localStorageForm.deliveryIndex) {
        this.deliveryIndex = localStorageForm.deliveryIndex
      }
      if (localStorageForm.fullAddress) {
        this.fullAddress = localStorageForm.fullAddress
      }
      if (localStorageForm.recipientPhone) {
        this.recipientPhone = localStorageForm.recipientPhone
      }
      if (!this.phone && localStorageForm.phone) {
        this.phone = localStorageForm.phone
      }
      if (localStorageForm.email) {
        this.email = localStorageForm.email
      }
      if (localStorageForm.apartment) {
        this.apartment = localStorageForm.apartment
      }
      if (localStorageForm.intercom) {
        this.intercom = localStorageForm.intercom
      }
      if (localStorageForm.porch) {
        this.porch = localStorageForm.porch
      }
      if (localStorageForm.floor) {
        this.floor = localStorageForm.floor
      }
      // if (localStorageForm.comment) {
      //   this.comment = localStorageForm.comment
      // }

      if (this.phone) {
        this.phone = '+' + this.phone
      }


      this.deliveryService = this.defaultDeliveryService()
      this.deliveryServiceType = this.defaultDeliveryServiceType()

      if (this.$store.getters.overlay === true) {
        this.$store.dispatch(DISABLE_OVERLAY)
      }

      this.persistFormToLocalStorage({
        name: this.name,
        fullName: this.fullName,
        localAddress: this.localAddress,
        cityName: this.cityName,
        fullAddress: this.fullAddress,
        deliveryIndex: this.deliveryIndex,
        recipientPhone: this.recipientPhone,
        phone: this.phoneITIInstance ? this.phoneITIInstance.getNumber() : null,
        apartment: this.apartment,
        intercom: this.intercom,
        porch: this.porch,
        floor: this.floor,
        comment: this.comment
      })

      this.payment = this.defaultMethod()

      if (this.$store.getters.outletSettings.payment_provider_id === 3) {
        this.loadCloudPaymentsScript()
      }
      if (this.$store.getters.outletSettings.payment_provider_id === 4) {
        this.loadWayForPayScript()
      }

      // Значение по-умолчанию для выбора времени (DELIVERY_DAYS_TIME)
      if (this.$store.getters.deliveryTimeMode === this.$store.getters.DELIVERY_DAYS_TIME) {
        setTimeout(() => {
          this.pickTime(this.$store.getters.outletSettings.delivery_time.today[0]);
          this.deliveryTime = this.$store.getters.outletSettings.delivery_time.today[0]
        }, 0);
      }

      if (this.deliveryTimeMode === this.DELIVERY_DAYS_TIME && !this.$store.getters.contactlessMode && !this.isOnlyDigitalItemsInBasket) {
        this.$store.dispatch(FETCH_TIMES)

        const currentDate = moment(new Date()).format().substring(0, 10)
        const daysInfo = this.$store.getters.outletSettings.delivery_time.days
        const todayInfo = this.$store.getters.outletSettings.delivery_time.today
        const keys = Object.keys(this.$store.getters.outletSettings.delivery_time.days)

        for (let day in daysInfo) {
          if (daysInfo[day] && daysInfo[day].length > 0) {
            if (daysInfo[day][0].match(/(\d+):(\d+) - (\d+):(\d+)/) !== null) {
              this.isIntervalDeliveryTime = true
            }
          }
        }

        if (this.$store.getters.outletSettings.accept_today === false) {
          const currentDate = moment(new Date()).format().substring(0, 10)
          for (let day in daysInfo) {
            if ((day != currentDate) && (daysInfo[day].length !== 0)) {
              this.deliveryDate = new Date(day)
              this.disableTime()
              if (this.isIntervalDeliveryTime) {
                this.intervalDeliveryTimeList = daysInfo[day].concat()
              }
              return
            }
          }
        } else if (this.$store.getters.outletSettings.accept_today === true && daysInfo[keys[0]].length === 0) {
          for (let day in daysInfo) {
            if ((day !== currentDate) && (daysInfo[day].length !== 0)) {
              this.deliveryDate = new Date(day)
              this.disableTime()
              if (this.isIntervalDeliveryTime) {
                this.intervalDeliveryTimeList = daysInfo[day].concat()
              }
              return
            }
          }
        } else {
          this.deliveryDate = new Date()
          this.disableTime()
          if (this.isIntervalDeliveryTime) {
            this.intervalDeliveryTimeList = todayInfo.concat()
          }
        }
      }
      if (!this.isIntervalDeliveryTime && !this.isOnlyDigitalItemsInBasket) {
        this.dateNowChecked = this.$store.getters.outletSettings.delivery_time.today.length > 0 && this.$store.getters.outletSettings.accept_today ? true : false
        this.isDateNowMode = this.dateNowChecked
        if (this.isDateNowMode) {
          this.updateTimeDelivery()
        }
      }

      if (this.$store.getters.deliveryServices.find(el => el.delivery_methods[0] ? el.delivery_methods[0].name === 'ПЭК' : false)) {
        this.calculateDeliveryMethods();
      }

    },

    watch: {
      deliveryIndex(val) {
        if (val.length === 0) {
          this.$store.commit(SET_SPECIAL_DELIVERY_METHOD, {})
        }
        debounce(() => this.calculateDeliveryMethods(val), 250)()
      },
      time(time) {
        if (time.getMinutes() % 5 === 0) {
          this.$store.dispatch(FETCH_TIMES)
        }
      },
      // cookComment: function (cookComment) {
      //   this.$store.commit(SET_COOK_COMMENT, cookComment)
      // },
      cashback: {
        deep: true,
        handler() {
          this.cashback.amount = parseInt(this.cashback.amount)
          if (isNaN(this.cashback.amount)) {
            this.cashback.amount = 0
          }
          if (this.cashback.use === false) {
            this.$store.commit(SET_TOTAL_PRICE, this.$store.getters.constTotalPrice)
          } else {
            this.$store.commit(SET_TOTAL_PRICE, this.$store.getters.constTotalPrice - this.cashback.amount)
          }
          if (this.cashback.amount > this.$store.getters.cashbackSettings.max) {
            this.cashback.amount = this.$store.getters.cashbackSettings.max
          }
          if (this.cashback.amount < 0) {
            this.cashback.amount = 0
          }
        }
      },
      deliveryService: {
        deep: true,
        handler(deliveryService) {
          if (!deliveryService) {
            return
          }
          if (deliveryService.form_settings) {
            this.$store.commit(SET_DELIVERY_TIME_OBJECT, {
              month: {value: null, data: null},
              day: {value: null, data: null},
              time: {value: null, data: null}
            })
            this.$store.commit(SET_TIME_SELECTOR, deliveryService.form_settings.timeSelector)
            this.$store.commit(SET_DELIVERY_TIME_MODE, deliveryService.form_settings.deliveryTimeMode)
            this.$store.commit(SET_FIELD_FULL_NAME, deliveryService.form_settings.formFullName)
            this.$store.commit(SET_FIELD_EMAIL, deliveryService.form_settings.formEmail)
            this.$store.commit(SET_FIELD_LOCAL_ADDRESS, deliveryService.form_settings.formLocalAddress)
            this.$store.commit(SET_FIELD_FULL_ADDRESS, deliveryService.form_settings.formFullAddress)
            this.$store.commit(SET_FIELD_CUSTOM_FIELDS, deliveryService.form_settings.formCustomFields)
            this.$store.commit(SET_FIELD_COMMENT, deliveryService.form_settings.formShowComment)

            this.updateOptionNumberOfPersons(deliveryService.form_settings.cutlery)

            if (!deliveryService.form_settings.formCustomField.required && this.requiredFields.includes('custom')) {
              let index = this.requiredFields.indexOf('custom')
              if (index !== -1) {
                this.requiredFields.splice(index, 1)
              }
            }
            this.$store.commit(SET_FIELD_RECIPIENT_PHONE, deliveryService.form_settings.formRecipientPhone)
            this.$store.commit(SET_FIELD_MAIN_PHONE, deliveryService.form_settings.formMainPhone)
          }
          if (deliveryService.payment_methods) {
            this.$store.commit(SET_PAYMENT_METHODS, deliveryService.payment_methods)
          }
          if (deliveryService.types.length === 0) {
            this.$store.commit(SET_TOTAL_PRICE, this.$store.getters.constTotalPrice + (deliveryService.price ? Number.parseFloat(deliveryService.price) : 0))
          }
        }
      },
      deliveryMethodCalcId: {
        deep: true,
        handler(deliveryMethodCalcId) {
          if (!this.deliveryIndex) {
            this.$refs.deliveryAddressPostCodeInput.$refs.deliveryIndex.focus()
            return
          }
        }
      },
      deliveryServiceType: {
        deep: true,
        handler(deliveryServiceType) {
          if (!deliveryServiceType) {
            return
          }
          if (deliveryServiceType.form_settings) {
            this.$store.commit(SET_DELIVERY_TIME_OBJECT, {
              month: {value: null, data: null},
              day: {value: null, data: null},
              time: {value: null, data: null}
            })
            this.$store.commit(SET_TIME_SELECTOR, deliveryServiceType.form_settings.timeSelector)
            this.$store.commit(SET_DELIVERY_TIME_MODE, deliveryServiceType.form_settings.deliveryTimeMode)
            this.$store.commit(SET_FIELD_FULL_NAME, deliveryServiceType.form_settings.formFullName)
            this.$store.commit(SET_FIELD_EMAIL, deliveryServiceType.form_settings.formEmail)
            this.$store.commit(SET_FIELD_LOCAL_ADDRESS, deliveryServiceType.form_settings.formLocalAddress)
            this.$store.commit(SET_FIELD_CUSTOM_FIELDS, deliveryServiceType.form_settings.formCustomFields)
            this.$store.commit(SET_FIELD_COMMENT, deliveryServiceType.form_settings.formShowComment)

            this.updateOptionNumberOfPersons(deliveryServiceType.form_settings.cutlery)

            if (deliveryServiceType.form_settings.formCustomFields) {
              deliveryServiceType.form_settings.formCustomFields.forEach(customField => {
                if (!customField.required && this.requiredFields.includes(`custom${customField.id}`)) {
                  let index = this.requiredFields.indexOf(`custom${customField.id}`)
                  if (index !== -1) {
                    this.requiredFields.splice(index, 1)
                  }
                }
              })
            }

            this.$store.commit(SET_FIELD_FULL_ADDRESS, deliveryServiceType.form_settings.formFullAddress)
            this.$store.commit(SET_FIELD_RECIPIENT_PHONE, deliveryServiceType.form_settings.formRecipientPhone)
            this.$store.commit(SET_FIELD_MAIN_PHONE, deliveryServiceType.form_settings.formMainPhone)
          }
          if (deliveryServiceType.payment_methods) {
            this.$store.commit(SET_PAYMENT_METHODS, deliveryServiceType.payment_methods)
          }
          return this.$store.commit(SET_TOTAL_PRICE, this.$store.getters.constTotalPrice + (deliveryServiceType.price ? Number.parseFloat(deliveryServiceType.price) : 0))
        }
      },
      deliveryMethod: {
        deep: true,
        handler(deliveryMethod) {
          if (!deliveryMethod) {
            return
          }
          this.$store.commit(SET_ACTIVE_DELIVERY_METHOD, deliveryMethod)
        }
      },
      paymentMethods: {
        deep: true,
        handler(paymentMethods) {
          if (!paymentMethods.hasOwnProperty(this.payment)) {
            this.payment = this.defaultMethod()
          }
        }
      },
      // Отслеживает переменную, изменяемую при работе с виджетом и снимает блокировку, когда виджет закрывается
      makeOrderStatus: function () {
        if (!this.makeOrderStatus) {
          this.blockOrderButton(false);
        }

      },
      // Отслеживает переменную, изменяемую при работе с "системным" попапом и снимает блокировку, когда попап закрывается
      systemPopupStatus: function () {
        if (!this.systemPopupStatus) {
          this.blockOrderButton(false);
        }

      }
    },
    methods: {
      getDatePickerLocale() {
        return this.language === 'ru'
            ? require('vue2-datepicker/locale/ru')
            : require('vue2-datepicker/locale/en')
      },
      async calculateDeliveryMethods(val) {
        const CDEK = this.$store.getters.deliveryServices.find(el => el.delivery_methods[0] ? el.delivery_methods[0].name === 'СДЭК' : false)
        const PR = this.$store.getters.deliveryServices.find(el => el.delivery_methods[0] ? el.delivery_methods[0].name === 'Почта России' : false)
        const PEK = this.$store.getters.deliveryServices.find(el => el.delivery_methods[0] ? el.delivery_methods[0].name === 'ПЭК' : false)
        if (PR) {
          await this.$store.dispatch(CALC_RUSSIAN_POST, {delivery_method_id: PR.delivery_methods[0].id, post_code: val})
        }
        if (CDEK) {
          await this.$store.dispatch(CALC_CDEK, {delivery_method_id: CDEK.delivery_methods[0].id, post_code: val})
        }
        if (PEK) {
          await this.$store.dispatch(CALC_TK_PEK, {delivery_method_id: PEK.delivery_methods[0].id})
        }
      },
      setFocusDaDataInput(value) {
        this.filledDaDataInput = value
      },
      updatePostalCode(value) {
        this.deliveryIndex = value
      },
      updateTimeDelivery() {
        this.dateNowChecked = true
        this.deliveryDate = new Date()
        const todayInfo = this.$store.getters.outletSettings.delivery_time.today
        this.deliveryTime = todayInfo[0]
        this.pickTime()
      },
      timeHandler() {
        this.deliveryTime = ''
        this.dateNowChecked = false
        this.disableTime()
      },
      disableTime() {
        this.dateNowChecked = false
        this.deliveryTime = ''
        this.intervalDeliveryTime = ''
        if (this.$refs.datePickerDate && this.$refs.datePickerDate.$refs && this.$refs.datePickerDate.$refs.input)
          this.$refs.datePickerDate.$refs.input.setAttribute('readOnly', true)
        if (!this.isIntervalDeliveryTime) {
          if (this.$refs.datePickerTime && this.$refs.datePickerTime.$refs && this.$refs.datePickerTime.$refs.input)
            this.$refs.datePickerTime.$refs.input.setAttribute('readOnly', true)
        }
        const currentDate = moment(this.deliveryDate).format().substring(0, 10)
        const today = moment(new Date()).format().substring(0, 10)
        const daysInfo = this.$store.getters.outletSettings.delivery_time.days
        const todayInfo = this.$store.getters.outletSettings.delivery_time.today

        if (currentDate === today) {
          if (this.isIntervalDeliveryTime) {
            this.intervalDeliveryTimeList = todayInfo.concat()
          } else {
            this.timeStart = todayInfo[0]
            this.timeEnd = todayInfo[todayInfo.length - 1] === '00:00' ? todayInfo[todayInfo.length - 2] : todayInfo[todayInfo.length - 1]
          }
        } else {
          for (let day in daysInfo) {
            if (currentDate === day) {
              if (this.isIntervalDeliveryTime) {
                this.intervalDeliveryTimeList = daysInfo[day].concat()
              } else {
                this.timeStart = daysInfo[day][0]
                this.timeEnd = daysInfo[day][daysInfo[day].length - 1] === '00:00' ? daysInfo[day][daysInfo[day].length - 2] : daysInfo[day][daysInfo[day].length - 1]
              }
            }
          }
        }
      },
      disabledBeforeTodayAndAfterAWeek(date) {
        const currentDate = moment(date).format().substring(0, 10)
        const today = moment(new Date()).format().substring(0, 10)
        const daysInfo = this.$store.getters.outletSettings.delivery_time.days
        const keys = Object.keys(daysInfo)
        const lastDay = keys[keys.length - 1]

        if (currentDate < today || currentDate > lastDay) {
          return true
        }

        for (let day in daysInfo) {
          if ((day === currentDate) && (daysInfo[day].length === 0) || ((this.$store.getters.outletSettings.accept_today === false) && (today === currentDate))) {
            return true
          }
        }
      },
      pickTime(setTime) {
        if (this.deliveryDate) {
          this.deliveryError = false
        }
        const dateNow = moment(this.deliveryDate).date() // костыль для momentJS
        const monthNow = moment(this.deliveryDate).month() // костыль для momentJS
        const yearNow = moment(this.deliveryDate).year() // костыль для momentJS
        let currentDate = moment(this.deliveryDate).utcOffset(this.$store.getters.outletSettings.timezone_offset).year(yearNow).month(monthNow).date(dateNow).locale(this.language)
        let label = this.$options.filters.capitalize(currentDate.format('MMMM')) + ' ' + currentDate.date() + ' (' + currentDate.format('dd') + ')'

        const day = {
          value: label,
          data: currentDate.date(),
          month: {
            value: currentDate.format('MMMM'),
            data: parseInt(currentDate.format('MM'))
          }
        }
        const month = {
          value: currentDate.format('MMMM'),
          data: parseInt(currentDate.format('MM'))
        }
        if (this.isIntervalDeliveryTime) {
          const time = {
            value: '',
            data: this.intervalDeliveryTime,
            label: ''
          }
          this.$store.commit(SET_DELIVERY_TIME_OBJECT, {
            day: day,
            time: time,
            month: month
          })
        } else if (!this.isIntervalDeliveryTime && this.deliveryTimeMode === this.DELIVERY_DAYS_TIME) {
          let times, data
          let offset = currentDate.utcOffset()
          if (this.$store.getters.timeFormat12) {
            times = moment(this.deliveryTime, 'h:mm A')
          } else {
            if (setTime !== undefined && setTime !== null && setTime !== '') {
              times = moment(setTime, 'HH:mm')
            } else {
              times = moment(this.deliveryTime, 'HH:mm')
            }
          }
          currentDate.hour(times.hour())
          currentDate.minute(times.minute())
          currentDate.second(0)
          data = currentDate.utcOffset(0).unix()
          currentDate.utcOffset(offset)

          const time = {
            value: this.$store.getters.timeFormat12 ? currentDate.format('mm A') : currentDate.format('mm'),
            data: data,
            label: this.$store.getters.timeFormat12 ? currentDate.format('hh:mm A') : currentDate.format('HH:mm')
          }
          this.$store.commit(SET_DELIVERY_TIME_OBJECT, {
            day: day,
            time: time,
            month: month
          })
        }
      },
      showApplePayGooglePay(paymentMethod) {
        return paymentMethod.id === 1 && this.$store.getters.outletSettings.payment_provider_id === 3
      },

      changeCount(value) {
        if (this.qtyDevices + value < 0) {
          return
        }
        this.qtyDevices += value
      },

      openTimeModal() {
        if (this.deliveryTimeMode !== this.DELIVERY_DAYS_TIME) {
          this.$store.commit(SET_MODAL, {modal: 'time', status: true})
        }
        if (this.deliveryTimeMode === this.DELIVERY_DAYS_TIME && !this.isIntervalDeliveryTime && this.$store.getters.outletSettings.delivery_time.today.length > 0 && this.$store.getters.outletSettings.accept_today) {
          this.openDeliveryTime = !this.openDeliveryTime
        }
      },

      loadCloudPaymentsScript() {
        var script = document.createElement('script')
        script.src = 'https://widget.cloudpayments.ru/bundles/cloudpayments'
        document.head.appendChild(script)

      },
      loadWayForPayScript() {
        var script = document.createElement('script')
        script.id = 'widget-wfp-script'
        script.src = 'https://secure.wayforpay.com/server/pay-widget.js'
        document.head.appendChild(script)

        window.addEventListener('message', (event) => {
          if (event.origin === 'https://secure.wayforpay.com') {
            if (event.data === 'WfpWidgetEventClose') {
              this.$store.commit(SET_LOADING, {process: MAKE_ORDER, status: false})
              this.$store.commit(SET_STATUS, {process: MAKE_ORDER, status: false})
            }
            if (event.data === 'WfpWidgetEventPending') {
              this.$store.commit(SET_STATUS, {process: MAKE_ORDER, status: true})
            }
            if (event.data === 'WfpWidgetEventApproved') {
              this.$store.commit(SET_STATUS, {process: MAKE_ORDER, status: true})
            }
            if (event.data === 'WfpWidgetEventDeclined') {
              this.$store.commit(SET_STATUS, {process: MAKE_ORDER, status: false})
            }
          }

        })
      },

      persistFormToLocalStorage(form) {
        localStorage.setItem('form', JSON.stringify(form))
      },
      getFormFromLocalStorage() {
        try {
          let form = JSON.parse(localStorage.getItem('form'))
          if (form === null) {
            localStorage.removeItem('form')
            this.persistFormToLocalStorage({
              name: this.name,
              fullName: this.fullName,
              localAddress: this.localAddress,
              cityName: this.cityName,
              deliveryIndex: this.deliveryIndex,
              fullAddress: this.fullAddress,
              recipientPhone: this.recipientPhone,
              phone: this.phoneITIInstance ? this.phoneITIInstance.getNumber() : null,
              apartment: this.apartment,
              intercom: this.intercom,
              porch: this.porch,
              floor: this.floor,
              comment: this.comment
            })
            return this.getFormFromLocalStorage()
          }
          return form
        } catch (e) {
          localStorage.removeItem('form')
          this.persistFormToLocalStorage({
            name: this.name,
            fullName: this.fullName,
            localAddress: this.localAddress,
            cityName: this.cityName,
            deliveryIndex: this.deliveryIndex,
            fullAddress: this.fullAddress,
            recipientPhone: this.recipientPhone,
            phone: this.phoneITIInstance ? this.phoneITIInstance.getNumber() : null,
            apartment: this.apartment,
            intercom: this.intercom,
            porch: this.porch,
            floor: this.floor,
            comment: this.comment
          })
          return this.getFormFromLocalStorage()
        }
      },
      toggleCashbackUse() {
        this.cashback.use = !this.cashback.use
        if (this.cashback.use) {
          this.$nextTick(function () {
            window.scrollTo(0, document.body.scrollHeight)
          })
        }
      },
      getMomentDateFormatted(date, format) {
        return moment(date).format(format)
      },
      getNearestOrderPreparationDate() {
        const orderPreparationAvailableDates = this.$store.getters.outletSettings.delivery_time.days
        let nearestOrderPreparationDate = null

        if (!orderPreparationAvailableDates || !Object.entries(orderPreparationAvailableDates).length) {
          return null
        }

        for (const [day, timeList] of Object.entries(orderPreparationAvailableDates)) {
          if (timeList.length) {
            const firstAvailablePeriod = timeList[0]
            const isIntervalModeEnabled = firstAvailablePeriod.includes('-')
            const firstAvailableTime = isIntervalModeEnabled ? firstAvailablePeriod.substring(0, firstAvailablePeriod.indexOf('-')).trim() : firstAvailablePeriod
            const dateNotFormatted = `${day} ${firstAvailableTime}`
            const timezoneOffset = this.$store.getters.outletSettings.timezone_offset
            nearestOrderPreparationDate = moment(dateNotFormatted).utcOffset(timezoneOffset, true)
            break
          }
        }

        return nearestOrderPreparationDate
      },
      isOutletCanStartPrepareOrderNow() {
        const orderPreparationInterval = 5 // интервал между заказами (фикс, 5 мин)
        const orderPreparationTime = orderPreparationInterval + (+this.getMinutes() || 0) // ближайший заказ возможен не менее, чем через (мин)
        const desiredOrderPreparationDate = moment().add(orderPreparationTime, 'minute') // желаемая клиентом ближайшая дата заказа
        let nearestOrderPreparationDate = this.getNearestOrderPreparationDate()  // возможная ближайшая дата приготовления рестораном

        if (!nearestOrderPreparationDate) {
          return false
        }

        return desiredOrderPreparationDate.isAfter(nearestOrderPreparationDate)
      },
      getMinutes() {
        if (this.isDelivery) {
          if (this.$store.getters.outletSettings.avg_delivery_time) {
            return this.$store.getters.outletSettings.avg_delivery_time
          }
          return null
        } else {
          if (this.$store.getters.outletSettings.avg_cooking_time) {
            return this.$store.getters.outletSettings.avg_cooking_time
          }
          return null
        }
      },
      defaultMethod() {
        if (!this.paymentMethods || Object.keys(this.paymentMethods).length === 0) {
          return null
        }
        if (this.$store.getters.contactlessMode && this.$store.getters.enableOnlinePayment && this.paymentMethods.some(el => el.id === 4)) {
          return this.paymentMethods.find(el => el.id === 4)
        }
        for (let el in this.paymentMethods) {
          if (this.paymentMethods[el].custom === true) {
            continue
          }
          if (this.paymentMethods[el].id === 2 || this.paymentMethods[el].id === 4) {
            return this.paymentMethods[el]
          }
        }
        return this.paymentMethods[Object.keys(this.paymentMethods)[0]]
      },
      defaultDeliveryService() {
        if (this.$store.getters.deliveryServices.length === 0) {
          return null
        }
        if (this.$store.getters.deliveryServices.some(service => typeof service.delivery_methods[0] === 'object' && service.delivery_methods[0].hasOwnProperty('name') && (service.delivery_methods[0].name === 'СДЭК' || service.delivery_methods[0].name === 'Почта России'))) {
          this.hasSpecialDeliveryMethods = true
          return null
        }
        if (this.$store.getters.profile.delivery_service_id === null) {
          return this.$store.getters.deliveryServices[0]
        }
        for (let i in this.$store.getters.deliveryServices) {
          if (this.$store.getters.deliveryServices[i].id ===
            this.$store.getters.profile.delivery_service_id) {
            return this.$store.getters.deliveryServices[i]
          }
        }
        return this.$store.getters.deliveryServices[0]
      },
      defaultDeliveryServiceType() {
        let deliveryService = this.defaultDeliveryService()
        if (deliveryService === null || deliveryService.types.length === 0) {
          return null
        }
        if (this.$store.getters.profile.delivery_service_type_id === null) {
          return deliveryService.types[0]
        }
        for (let i in deliveryService.types) {
          if (deliveryService.types[i].id === this.$store.getters.profile.delivery_service_type_id) {
            return deliveryService.types[i]
          }
        }
        return deliveryService.types[0]
      },
      makeOrder: debounce(function() {
        let tipsAmount = 0
        if (
            this.$refs.tipsSelector &&
            this.$refs.tipsSelector.checked &&
            this.$refs.tipsSelector.tipsSum
        ) {
          tipsAmount = Number.parseInt(this.$refs.tipsSelector.tipsSum)
        }

        // if (this.isDateNowMode && this.dateNowChecked) {
        //   this.updateTimeDelivery()
        // }

        if (this.isPincode === true && this.pincodeCheck === false) {
          this.togglePin(true);
          return
        }

        this.$store.dispatch(FETCH_TIMES).then(async (res) => {
          if (this.timeSelector && !this.$store.getters.contactlessMode && !this.$store.getters.enableOnlinePayment && !this.isOnlyDigitalItemsInBasket) {
            if (this.deliveryTimeMode === this.DELIVERY_MONTHS_TIME &&
              (this.$store.getters.deliveryTimeObject.month.data === null ||
                this.$store.getters.deliveryTimeObject.day.data === null)) {
              this.openTimeModal()
              this.blockOrderButton(false);
              return
            }
            if (this.deliveryTimeMode === this.DELIVERY_DAYS_TIME &&
              !this.isIntervalDeliveryTime &&
              (this.$store.getters.deliveryTimeObject.day.data === null ||
                this.$store.getters.deliveryTimeObject.time.data === null ||
                !this.deliveryTime || !this.deliveryDate)) {
              if (this.isDateNowMode) {
                this.openDeliveryTime = true
              }
              // return this.openTimeModal()
              this.$refs.datePickerDate.$refs.input.scrollIntoView({behavior: 'smooth', block: 'center'})
              this.deliveryError = true
              this.blockOrderButton(false);
              return
            }
            if (this.deliveryTimeMode === this.DELIVERY_DAYS_TIME && this.isIntervalDeliveryTime && !this.intervalDeliveryTime) {
              this.$refs.datePickerDate.$refs.input.scrollIntoView({behavior: 'smooth', block: 'center'})
              this.deliveryError = true
              this.blockOrderButton(false);
              return
            }
            if (this.deliveryTimeMode === this.DELIVERY_DAYS_TIME && this.isIntervalDeliveryTime && !this.deliveryDate) {
              this.$refs.datePickerDate.$refs.input.scrollIntoView({behavior: 'smooth', block: 'center'})
              this.deliveryError = true
              this.blockOrderButton(false);
              return
            }
            if (this.deliveryTimeMode === this.DELIVERY_DAYS_TIME) {
              const currentDate = moment(this.deliveryDate).format().substring(0, 10)
              const today = moment(new Date()).format().substring(0, 10)
              const todayInfo = res.today

              if (this.deliveryTime && currentDate === today && !this.isIntervalDeliveryTime) {
                let label = this.$store.getters.deliveryTimeObject.time.label
                if (!todayInfo.some(time => time === label)) {
                  if (this.dateNowChecked) {
                    this.deliveryTime = todayInfo[0]
                    this.pickTime()
                  } else {
                    if (this.isDateNowMode) {
                      this.openDeliveryTime = true
                    }
                    this.deliveryTime = ''
                    this.$refs.datePickerDate.$refs.input.scrollIntoView({behavior: 'smooth', block: 'center'})
                    this.deliveryError = true
                    this.blockOrderButton(false);
                    return
                  }
                }
              }
            }
            if (
              this.deliveryTimeMode === this.DELIVERY_TIME && this.$store.getters.deliveryTimeObject.day.data === null ||
              (this.$store.getters.outletSettings.delivery_time.today.length === 0 &&
                this.$store.getters.deliveryTimeObject.time.data === null)
            ) {
              this.openTimeModal()
              this.blockOrderButton(false);
              return
            }
          }

          let formErrors = []

          if (this.$store.getters.formNameRequired && !this.name.length && !this.$store.getters.contactlessMode) {
            if (this.$store.getters.shopMode === 0 ? this.$store.getters.outlet.data.webview_settings.formNameShow : this.$store.getters.outlet.webview_settings.formNameShow) {
              formErrors.push('name')
            }
          }

          if (this.$store.getters.fieldMainPhone && this.$store.getters.formMainPhoneRequired &&
              this.phoneITIInstance && !this.phoneITIInstance.isValidNumber()) {
            formErrors.push('phone')
          }

          if ((this.isDelivery || this.deliveryService) && this.fieldLocalAddress && !this.isOnlyDigitalItemsInBasket) {
            if (!this.$store.getters.outletSettings.company_use_kml) {
              if (this.localAddress.length === 0) {
                formErrors.push('localAddress')
              }
            }
          }

          // if (this.hasSpecialDeliveryMethods && !this.$store.getters.specialDeliveryMethod.id) {
          //   formErrors.push('deliveryIndex')
          // }

          if ((this.isDelivery || this.deliveryService) && this.fieldFullAddress && this.fullAddress.length === 0 && !this.isOnlyDigitalItemsInBasket) {
            formErrors.push('fullAddress')
          }

          if ((this.isDelivery || this.deliveryService) && this.fieldFullName && this.fullName.length === 0) {
            formErrors.push('fullName')
          }

          if ((this.isDelivery || this.deliveryService) && this.fieldRecipientPhone && this.recipientPhone.length === 0) {
            formErrors.push('recipientPhone')
          }

          const fieldCustomFields = this.$store.getters.fieldCustomFields
          if (fieldCustomFields.length > 0) {
            fieldCustomFields.forEach(customField => {
              if (customField.required && !customField.value) {
                formErrors.push(`custom${customField.id}`)
              }
            })
          }

          const districtCustomFields = this.$store.getters.guardAreaID !== null ? this.$store.getters.guardAreaID.form_settings.formCustomFields : [];
          if (districtCustomFields.length > 0) {
            districtCustomFields.forEach(customField => {
              if (customField.required && !customField.value) {
                formErrors.push(`custom${customField.id}`)
              }
            })
          }
          if (this.fieldEmail && ( this.$store.getters.formEmailRequired || this.hasDigitalItem ) && this.email.length === 0 ) {
            let re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
            if (!this.email.match(re)) {
              formErrors.push('email')
            }
          }

          this.requiredFields = formErrors
          if (this.requiredFields.length !== 0) {
            this.focus(this.requiredFields[0], this.requiredFields[0], true)
            this.blockOrderButton(false);
            return
          }

          if (this.payment && this.payment.custom !== true && this.payment.id !== 2) {
            this.delivery = ''
          }

          this.persistFormToLocalStorage({
            name: this.name,
            fullName: this.fullName,
            localAddress: this.localAddress,
            cityName: this.cityName,
            deliveryIndex: this.deliveryIndex,
            fullAddress: this.fullAddress,
            recipientPhone: this.recipientPhone,
            phone: this.phoneITIInstance ? this.phoneITIInstance.getNumber() : null,
            apartment: this.apartment,
            intercom: this.intercom,
            porch: this.porch,
            floor: this.floor,
            comment: this.comment
          })

          let deliveryService = {
            id: null,
            type: null
          }

          if (this.deliveryService) {
            deliveryService.id = this.deliveryService.id
            if (this.deliveryServiceType) {
              deliveryService.type = this.deliveryServiceType.id
            }
          }

          let paymentMethod = this.payment
          let customPaymentMethod = this.payment
          if (this.payment) {
            if (this.payment.custom === true) {
              paymentMethod = null
              customPaymentMethod = this.payment.id
            } else {
              customPaymentMethod = null
              paymentMethod = this.payment.id
            }
          }

          let commentCurrent
          // if (this.$store.getters.basketComment) {
          //   console.log('basketComment: ' + this.$store.getters.basketComment + ' ' + this.$store.getters.cookComment);
          //   commentCurrent = this.$store.getters.cookComment
          // } else if (this.fieldComment) {
            commentCurrent = this.comment
          // } else {
          //   commentCurrent = ''
          // }

          const isDgsnWidgetRoot = function () {
            try {
              return window.self !== window.top
            } catch (e) {
              return true
            }
          }

          let localFieldCustomFields = []
          if (fieldCustomFields.length > 0) {
            localFieldCustomFields = fieldCustomFields.map(customField => {
              return {
                id: customField.id,
                value: customField.value
              }
            })
          }

          const specialDeliveryMethod = this.$store.getters.specialDeliveryMethod

          this.makeOrderPayload = {
            address: this.address,
            flat: this.apartment,
            cashback: this.cashback,
            porch: this.porch,
            email: this.email,
            floor: this.floor,
            domofon: this.intercom,
            comment: commentCurrent,
            changing: this.delivery,
            city_name: this.$store.getters.deliveryToCity ? this.$store.getters.deliveryToCity : this.cityName,
            dadata_street: this.street !== '' ? this.street : (this.$store.getters.dadataStreet ? this.$store.getters.dadataStreet : null),
            qty_devices: this.qtyDevices,
            deliveryService: deliveryService,
            deliveryMethodCalcId: specialDeliveryMethod.id ? specialDeliveryMethod.id : null,
            delivery_method_pvz_id: this.$store.getters.deliveryMethodPvzId,
            delivery_method_pvz_data: this.$store.getters.deliveryMethodPvzData,
            payment: paymentMethod,
            paymentCustom: customPaymentMethod,
            name: this.name,
            formCustomFields: (localFieldCustomFields.length > 0 || districtCustomFields.length > 0) ? [...localFieldCustomFields, ...districtCustomFields] : [],
            phone: this.phoneITIInstance ? this.phoneITIInstance.getNumber() : null,
            fullName: (this.isDelivery || this.deliveryService) && this.fieldFullName ? this.fullName : null,
            localAddress: (this.isDelivery || this.deliveryService) && this.fieldLocalAddress && !this.$store.getters.outletSettings.company_use_kml ? this.localAddress : null,
            fullAddress: (this.isDelivery || this.deliveryService) && this.fieldFullAddress ? this.fullAddress : null,
            recipientPhone: (this.isDelivery || this.deliveryService) && this.fieldRecipientPhone
              ? this.recipientPhone
              : null,
            isDgsnWidgetRoot: isDgsnWidgetRoot(),
            tips_amount: tipsAmount,
          }

          if (this.isStore) {
            this.$store.commit(SET_LOADING, {process: MAKE_ORDER, loading: true})
            let confirmed = await this.isSmsConfirmed(this.phoneITIInstance ? this.phoneITIInstance.getNumber() : null)
            this.$store.commit(SET_LOADING, {process: MAKE_ORDER, loading: false})

            if (!confirmed) {
              this.phone = this.phoneITIInstance ? this.phoneITIInstance.getNumber() : null
              // this.$store.commit(SET_MODAL, {modal: 'sms', status: true})
              this.toggleSms(true);
              this.blockOrderButton(false);
              return
            }
          }

          if (this.$store.getters.guardCheckIiko === 1) {
            this.$store.dispatch(MAKE_ORDER, this.makeOrderPayload).then(res => {
              if (res === true) {
                setTimeout(() => {
                  this.$store.dispatch(CHECK_IIKO, this.makeOrderPayload)
                }, 1000)
              }
            })
            // this.blockOrderButton(false)
          } else {
            this.$store.dispatch(MAKE_ORDER, this.makeOrderPayload)
            // this.blockOrderButton(false);
          }
        })

      }, 2000),
      focus(what, id = null, scroll = false) {
        if (this.focused === what) {
          return
        }
        this.focused = what

        if (id) {
          if (scroll) {
            VueScrollTo.scrollTo(document.getElementById(id), 100, {
              offset: -100,
              force: true
            })
          }
          document.getElementById(id).focus()
        }

      },
      isSmsConfirmed(phone) {
        return axios({
          method: 'POST',
          url: api.sms.isConfirmed.url(),
          data: {
            phone
          }
        }).then(response => response.data.confirmed);
      },
      unfocus() {
        this.focused = ''
      },
      moment: function () {
        return moment()
      },
      /**
       * Изменить опцию "Кол-во персон"
       */
      updateOptionNumberOfPersons(value) {
        // При изменении типа сервиса доставки или сервиса доставки, считываем настройку "Кол-во персон"
        // Если внутр. переменная кол-во персон qtyDevices уже была изменена, не меняем ее
        this.$store.commit(SET_CUTLERY, value)
        if (this.qtyDevices <= 1) {
          this.qtyDevices = this.$store.getters.cutlery ? 1 : 0
        }
      },

      // Функция блокирует/разблокирует кнопку оформления заказа.
      blockOrderButton(bool) {
        this.$store.commit(SET_LOADING, {process: MAKE_ORDER, loading: bool});
        this.isOrderButtonBlocked = bool;
      },

      // Отправка ПИН кода на проверку
      checkPinCode() {
          axios({
            method: 'POST',
            url: api.order.createCheckPincode.url(),
            data: {
              pincode: this.pincode
            }
        }).then(response => {
            this.togglePin(false);
            this.pincodeCheck = true;
            this.blockOrderButton(true);
            this.makeOrder();
        }).catch(error => {
            this.pincodeError = true;
        }).finally(() => {

        })
      },

      // Открыть/закрыть проверку пин кода
      togglePin(bool) {
        this.pincodeModal = bool;
        this.blockOrderButton(false);
      },

      // Открыть/закрыть проверку смс
      toggleSms(bool) {
        this.smsModal = bool;
      }

    },
    computed: {
      currentDeliveryDateNowText() {
        if (!this.dateNowChecked && this.deliveryDate && this.deliveryTime) {
          const currentDate = this.language === 'ru'
              ? moment(this.deliveryDate).format('DD.MM.YYYY')
              : moment(this.deliveryDate).format().substring(0, 10)
          const times = moment(this.deliveryTime).format().substring(11, 16)
          return currentDate + ' ' + this.text('screen_form_at_time', { 'time': times })
        }
        if (!this.dateNowChecked && (!this.deliveryDate || !this.deliveryTime)) {
          return this.text('screen_form_select_date_and_time')
        }
        if (this.dateNowChecked && this.isOutletCanStartPrepareOrderNow()) {
          return this.text('screen_form_as_fast_as_you_can')
        }
        const nearestDateFormatted = this.getMomentDateFormatted(this.getNearestOrderPreparationDate(), (this.language === 'ru' ? 'DD.MM.YYYY' : 'YYYY-MM-DD'))
        const nearestTimeFormatted = this.getMomentDateFormatted(this.getNearestOrderPreparationDate(), 'HH:mm')
        return `${nearestDateFormatted} ${this.text('screen_form_at_time', { 'time': nearestTimeFormatted })}`
      },
      outletAddress() {
        if (this.$store.getters.outlet.data) {
          return this.$store.getters.outlet.data.address
        }
        if (this.$store.getters.outlet.outlet) {
          return this.$store.getters.outlet.outlet.address
        }
      },
      isStore() {
        return this.$store.getters.token === process.env.VUE_APP_WEB_TOKEN
      },
      orderButtonText() {
        return (this.payment && this.payment.custom !== true && this.payment.id === 1 && this.$store.getters.totalPrice !== 0) ? this.text('screen_form_cashback_go_pay') :
          this.text('screen_form_cashback_make_order')
      },
      makeOrderStatus() {
        return this.$store.getters.status[MAKE_ORDER] === true
      },
      systemPopupStatus() {
        return this.$store.getters.modal.system === true
      },
      isDelivery() {
        return this.$store.getters.outletSettings.delivery_type === 3
      },
      deliveryType() {
        if (this.$store.getters.outletSettings.delivery_type === 3) {
          return this.text('screen_form_deliver')
        }
        if (this.$store.getters.outletSettings.delivery_type === 2) {
          return this.text('screen_form_prepare')
        }
        if (this.$store.getters.outletSettings.delivery_type === 1) {
          return this.text('screen_form_prepare')
        }
      },
      intervalMode() {
        if (this.$store.getters.outletSettings.delivery_type === 3) {
          return this.$store.getters.outletSettings.delivery_interval_mode === true
        }
        if (this.$store.getters.outletSettings.delivery_type === 2) {
          return this.$store.getters.outletSettings.other_interval_mode === true
        }
        if (this.$store.getters.outletSettings.delivery_type === 1) {
          return this.$store.getters.outletSettings.pickup_interval_mode === true
        }
      },
      isFreeOrder() {
        return this.$store.getters.totalPrice === 0
      },
      ...mapGetters([
        'timeSelector', 'showAgreeText', 'deliveryTimeMode', 'paymentMethods',
        'fieldFullName', 'fieldEmail', 'fieldFullAddress', 'fieldLocalAddress', 'fieldRecipientPhone', 'fieldComment',
        'DELIVERY_TIME', 'DELIVERY_DAYS_TIME', 'DELIVERY_MONTHS_TIME', 'DELIVERY_ONE_DAY', 'time',
        'deliveryTimeObject', 'language', 'timeFormat12', 'basketComment'
      ])
    },
  }
</script>

<style scoped>
  .iterval-time {
    margin-top: 10px;
  }

  .qty_devices_block {
    display: -webkit-box;
    display: flex;
    padding: 16px;
    width: 100%;
    box-sizing: border-box;
  }

  .delivery {
    margin-top: 24px;
  }

  .select_block-calendar {
    height: auto;
    padding: 10px 56px 15px;
  }

  .select_block-calendar:before {
    display: none;
  }

  .mx-datepicker {
    width: 100%;
  }

  .mx-datepicker + .mx-datepicker {
    margin-top: 10px;
  }

  .delivery-error {
    border: 2px solid red;
    border-radius: 7px;
  }

  .sb_title {
    font-size: 12px;
    line-height: 120%;
    color: #999999;
  }

  .sb_select {
    font-size: 15px;
    line-height: 120%;
    color: #1a1a1b;
    margin-top: 2px;
  }

  .sb_select span {
    color: #0084ff;
  }

  .delivery_form {
    display: block;
    margin-top: 20px;
  }

  .delivery_form .input_style + .input_style,
  .delivery_form .in_2 + .input_style,
  .delivery_form .input_style + .in_2,
  .in_2 + .in_2 {
    margin-top: 12px;
  }

  .input span.required {
    position: absolute;
    right: 16px;
    top: 5px;
    white-space: nowrap;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: #eb4253;
  }

  .in_2 {
    display: flex;
    margin-left: -16px;
  }

  .in_2_block {
    width: 50%;
    padding-left: 16px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .delivery_oplata {
    margin-top: 41px;
  }

  .do_title {
    font-weight: 500;
    font-size: 20px;
    line-height: 120%;
    color: #000;
  }

  .delivery_oplata_list {
    margin-top: 18px;
  }

  .dol_block {
    display: block;
    position: relative;
  }

  .dol_block input {
    display: none;
  }

  .dol_block + .dol_block {
    margin-top: 8px;
  }

  .dol_content {
    position: relative;
    background: #f5f5f5;
    border-radius: 16px;
    padding-left: 57px;
    padding-right: 55px;
    padding-top: 21px;
    padding-bottom: 21px;
    -webkit-transition: 0.3s;
    -moz-transition: 0.3s;
    -ms-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
  }

  .dol_block input:checked + .dol_content:after {
    opacity: 1;
  }

  .dol_block input:checked + .dol_content:before {
    border-color: #0084ff;
  }

  .dol_block input:checked + .dol_content .dol_name {
    font-weight: 500;
  }

  .dol_ico {
    position: absolute;
    height: 100%;
    display: flex;
    top: 14px;
    left: 12px;
    width: 32px;
    height: 32px;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .dol_ico svg {
    display: block;
  }

  .dol_name {
    font-size: 15px;
    line-height: 120%;
    color: #1a1a1b;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    -ms-transition: 0.2s;
    -o-transition: 0.2s;
    transition: 0.2s;
  }

  input.dol_dop_input:focus::placeholder {
    color: transparent;
  }

  .dol_dop_text {
    font-size: 12px;
    line-height: 16px;
    color: #999;
    padding-top: 5px;
  }

  .dol_dop_text span {
    font-weight: 500;
  }

  .dol_dop {
    visibility: hidden;
    opacity: 0;
    overflow: hidden;
    height: 0;
    -webkit-transition: 0.3s;
    -moz-transition: 0.3s;
    -ms-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
  }

  .dol_block input:checked + .dol_content .dol_dop {
    visibility: visible;
    opacity: 1;
    height: auto;
    overflow: visible;
  }

  .dol_block input:checked + .dol_content {
    background: #eaf5fe;
  }

  .dol_block input:checked + .dol_content svg path {
    fill: #0084ff;
  }

  .dol_dop input {
    display: block;
    border: none;
    text-align: center;
    width: 96px;
    margin: 0;
    padding: 0;
    background: none;
    font-size: 12px;
    color: #999;
    height: 15px;
    padding-bottom: 2px;
    padding-top: 11px;
    border-bottom: 1px solid #ccc;
  }

  .pu_tovar_nav_one {
    display: block;
  }

  .pu_tovar_nav_one .pu_tovar_nav_btn {
    margin: 0;
    padding: 0;
  }

  .pu_tovar_nav_one .fbb_btn {
    padding-left: 0;
    text-align: center;
    padding-right: 0;
  }

  .pu_select {
    width: 328px;
    position: relative;
    margin: 0 auto;
    margin-bottom: 84px;
    display: flex;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .pu_select:before,
  .pu_select:after {
    /*content: "";*/
    /*display: block;*/
    /*position: absolute;*/
    /*width: 100%;*/
    /*height: 1px;*/
    /*background: #F0F0F0;*/
    /*left: 0;*/
    /*top: 96px;*/
    /*-webkit-perspective: none;*/
    /*   -moz-perspective: none;*/
    /*        perspective: none;*/
  }

  .pu_select:after {
    top: 141px;
  }

  .pu_select_block {
    height: 238px;
    width: 50%;
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .pu_select_block:before,
  .pu_select_block:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 90px;
    background: #fff;
    opacity: 0.6;
    left: 0;
    pointer-events: none;
    z-index: 20;
  }

  .pu_select_block:before {
    top: 0;
  }

  .pu_select_block:after {
    bottom: 0;
  }

  .pu_select_list {
    display: block;
    margin: 0;
    padding: 0;
    list-style: none;
    padding-top: 4px;
    padding-bottom: 6px;
    padding-left: 43px;
  }

  .pu_select_block + .pu_select_block .pu_select_list {
    padding-left: 0;
    padding-right: 43px;
  }

  .pu_select_list > li {
    display: block;
    height: 46px;
    text-align: center;
    line-height: 46px;
    font-size: 18px;
    font-weight: 500;
    color: #1a1a1b;
    white-space: nowrap;
  }

  a.buttonBlocked {
    pointer-events: none;
    opacity: 0.7;
  }

  /*@media*/
  @media screen and (max-width: 340px) {
    .pu_tovar_nav .plus-minus {
      width: 90px;
      min-width: 90px;
    }

    .pu_tovar_nav .cart__count-down,
    .pu_tovar_nav .cart__count-up {
      width: 30px;
    }

    .pu_tovar_nav .cart__count-down {
      left: 0;
    }

    .pu_tovar_nav .cart__count-up {
      right: 0;
    }

    .pu_tovar_nav .fbb_btn {
      padding-left: 16px;
    }
  }

  .form-info {
    display: flex;
    background: #fdf0f1;
    border-radius: 16px;
    font-size: 15px;
    line-height: 18px;
    padding: 20px 19px 20px 18px;
    background: #f5f5f5;
    margin-top: 26px;
    -webkit-align-items: center;
    align-items: center;
  }

  .form-info span {
    font-weight: 500;
  }

  .form-info img {
    display: block;
    margin-right: 18px;
  }

  .pu_select__date-now {
    padding-top: 20px;
  }

  .pu_bottom-date-now {
    z-index: 99999 !important;
  }

  .pu_dark-date-now {
    z-index: 10000 !important;
  }

  .pincode {

  }

  .pincode__info {
    margin-top: 30px;
  }

  .pincode__input {
    margin-top: 30px;
  }

  .pincode__input_error {
    color: red;
    text-align: center;
    opacity: 0;
  }
  .pincode__input_error.show {
    opacity: 1;
  }

  .pincode__button {
    margin-top: 30px;
  }

  .pincode__error {
    margin-top: 30px;
    color: red;
    font-size: 14px;
  }

  .custom-order-text {
    margin-bottom: 20px;
  }
</style>
